import { Center, Flex, Text } from '@chakra-ui/react';

export function NotFound(): React.JSX.Element {
  return (
    <Center h="100vh" w="full">
      <Flex direction="column" textAlign="center">
        <Text fontSize="2xl">404 • Not Found</Text>
      </Flex>
    </Center>
  );
}
